export default "__VITE_ASSET__C0BQbc4W__"